import { apiFetch } from "../api/client.js";

export async function downloadAuthenticatedPdf(path, fileName) {
  const blob = await apiFetch(path);
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.setTimeout(() => URL.revokeObjectURL(url), 30000);
}
